import { GamePrivacy } from "../../enum/game";
import GameState from "../../enum/gamestate";

export enum GetGamesForUserType {
    All = 0,
    Active,
    Completed,
    Open,
    Live,
}

export const GET_GAMES_COMPLETED_PAGE_SIZE: number = 50;
export const COMPLETED_GAMES_LIST_DEFAULT_PAGE_SIZE: number = 20;

export type GetGamesForUserParams = {
    searchType?: GetGamesForUserType;
    take?: number;
    cursor?: number;
    gameIds?: number[];
    state?: GameState;
    privacy?: GamePrivacy;
}

type GetRandomGameNameSuccess = {
    status: 'ok';
    name: string;
}

type GetRandomGameNameError = {
    status: 'error';
    message: string;
};

export type GetRandomGameNameResult = GetRandomGameNameSuccess | GetRandomGameNameError;

type SetSlackIdSuccess = {
    status: 'ok',
};

type SetSlackIdError = {
    status: 'error';
    message: string;
};

export type SetSlackIdResponse = SetSlackIdSuccess | SetSlackIdError;

export type CheckSlackIdResponse = {
    status: 'ok' | 'notok';
};
